import React from 'react';

import { I18n } from 'js/components/common/I18n';
import { LocalPopup } from 'js/components/common/Popup';

import { useTranslations } from 'js/hooks/i18n';
import { useModalAlreadyUser } from 'js/components/system/App/buzz/hooks/useModalAlreadyUser';

import style from './AlreadyUserPopup.scss';

export const AlreadyUserPopup = () => {
    const t = useTranslations('playtech.mobile.system.registration.');
    const { isShowPopupAlreadyUser, closePopupAlreadyUser } = useModalAlreadyUser();

    if (!isShowPopupAlreadyUser) {
        return null;
    }

    return (
        <LocalPopup
            className={style.container}
            title={t('alreadyUser.modal.title')}
            onClose={closePopupAlreadyUser}
            buttons={[{
                text: t('alreadyUser.modal.btn'),
                size: 'medium',
                view: 'secondary',
                className: style.button,
                onClick: closePopupAlreadyUser
            }]}
        >
            <I18n
                t={t}
                className={style.text}
                tKey="alreadyUser.modal.content"
            />
        </LocalPopup>
    );
};
